import React, { useState, useEffect} from 'react'
import { Link } from 'react-scroll'
import { Link as Linkto } from 'react-router-dom'
import Logo from './images/STTelemedia.png'
import './Navbar.css'

const Navbar = () => {

    const [isOpen, setIsopen] = useState(false);

    const ToggleSidebar = () => {
        isOpen === true ? setIsopen(false) : setIsopen(true);
    }

    const [navBackground, setNavBackground] = useState('appBarTransparent')
    const navRef = React.useRef()
    navRef.current = navBackground
    useEffect(() => {
        const handleScroll = () => {
            const show = window.scrollY > 90
            if (show) {
                setNavBackground('ease-in duration-300 bg-white w-full fixed z-0 top-0 left-0')
            } else {
                setNavBackground('ease-in duration-300 bg-white w-full fixed z-0 top-0 left-0')
            }
        }
        document.addEventListener('scroll', handleScroll)
        return () => {
            document.removeEventListener('scroll', handleScroll)
        }
    }, [])

    return (
    <div className='header' >
        <nav style={{backgroundColor: "#222222"}} className="ease-in duration-300 opacity-90 w-full fixed z-0 top-0 left-0">
        <div className=" flex flex-wrap items-center justify-between mx-auto p-4">
        <Link to="hero" className="cursor-pointer flex items-center">
            <p className='py-2 pl-4 text-xs md:text-base text-white font-bold'>JAPAN-SOUTHEAST ASIA MARKET FORUM 2025</p>
        </Link>

        <div className="flex order-2">
        
            <button onClick={ToggleSidebar}  data-collapse-toggle="navbar-sticky" type="button" className="inline-flex items-center p-2 text-sm rounded-lg lg:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 " aria-controls="navbar-sticky" aria-expanded="false">
                <svg className="w-6 h-6" aria-hidden="true" fill="#fff" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"></path></svg>
            </button>
        </div>
        
        <div className="items-center justify-between hidden w-full lg:flex lg:w-auto lg:order-3" id="navbar-sticky">
            <ul className="mr-4 flex flex-col p-4 lg:p-0 mt-4 font-medium rounded-lg lg:flex-row lg:space-x-8 lg:mt-0">
            {/*<li className='text-base cursor-pointer py-2'>
                <Link spy={true} offset={-45} smooth={true} duration={500} to="agenda" className="sttelemedia text-white py-2 pl-3 pr-4 hover:text-purple-800  md:p-0" aria-current="page">AGENDA</Link>
            </li>
            <li className='text-base cursor-pointer py-2'>
                <Link spy={true} offset={-45} smooth={true} duration={500} to="overview" className="sttelemedia  text-white py-2 pl-3 pr-4  hover:text-purple-800 md:p-0">OVERVIEW</Link>
            </li>
            <li className='text-base cursor-pointer py-2'>
                <Link spy={true} offset={-45} smooth={true} duration={500} to="outline" className="sttelemedia  text-white py-2 pl-3 pr-4  hover:text-purple-800  md:p-0">OUTLINE</Link>
            </li>
            <li className='text-base cursor-pointer py-2'>
                <Link spy={true} offset={-45} smooth={true} duration={500} to="contact" className="sttelemedia  text-white py-2 pl-3 pr-4  hover:text-purple-800  md:p-0">CONTACT</Link>
            </li>*/}
            <div activeClass="text-black text-base" spy={true} offset={-45} smooth={true} duration={500} to="registration"  className='text-base cursor-pointer bg-red-700 px-2 rounded-lg py-2'>
                <Linkto to="/form" className="sttelemedia  rounded-2xl text-white py-2 pl-3 pr-4 hover:bg-gray-100 md:hover:bg-transparent md:hover:text-black md:p-0">REGISTER NOW</Linkto>
            </div>
            </ul>
        </div>
        </div>
        {isOpen ? <div className='dropdown-nav' style={{backgroundColor: "#222222"}}>
        <ul className="font-medium text-center">
            {/*<li className='text-base cursor-pointer py-2'>
                <Link onClick={ToggleSidebar}  spy={true} offset={-45} smooth={true} duration={500} to="agenda" className="sttelemedia text-white py-2 pl-3 pr-4  hover:text-purple-800   md:p-0" aria-current="page">AGENDA</Link>
            </li>
            <li className='text-base cursor-pointer py-2'>
                <Link onClick={ToggleSidebar} spy={true} offset={-45} smooth={true} duration={500} to="overview" className="sttelemedia  text-white py-2 pl-3 pr-4 hover:text-purple-800 md:p-0">OVERVIEW</Link>
            </li>
            <li className='text-base cursor-pointer py-2'>
                <Link onClick={ToggleSidebar}  spy={true} offset={-45} smooth={true} duration={500} to="outline" className="sttelemedia  text-white py-2 pl-3 pr-4 hover:text-purple-800  md:p-0">OUTLINE</Link>
            </li>
            <li className='text-base cursor-pointer py-2'>
                <Link onClick={ToggleSidebar} spy={true} offset={-45} smooth={true} duration={500} to="contact" className="sttelemedia  text-white py-2 pl-3 pr-4 hover:text-purple-800  md:p-0">CONTACT</Link>
            </li>*/}
            <li className='text-base cursor-pointer py-2'>
            <Linkto to="/form" ><button className='hover:text-black text-white block text-base cursor-pointer bg-red-700 px-20 rounded-lg py-2 w-full'>REGISTER NOW</button></Linkto>
            </li>
           
           
            </ul>
        </div> :<div></div> }
        </nav>

    </div>
  )
}

export default Navbar
